import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'
import moment from 'moment'

type PromoCreateRequest = {
    type: typeof ActionTypes.PROMO_CREATE_REQUEST;
    payload: never;
}

type PromoCreateFailure = {
    type: typeof ActionTypes.PROMO_CREATE_FAILURE;
    payload: Error;
}

type PromoCreateSuccess = {
    type: typeof ActionTypes.PROMO_CREATE_SUCCESS;
    payload: Promo & {
        filename: string;
        upload_id: string;
    };
}

export type PromoCreation = Omit<Promo, 'id' | 'asset_url'> & { promo_img: File }

const CreateDeviceFields = [
    'date_end',
    'date_start',
    'exception_countries',
    'exception_dates',
    'exception_devices',
    'exception_price_gt',
    'exception_price_lt',
    'exception_stores',
    'exception_skus',
    'group_brand',
    'group_skus',
    'name',
    'priority',
    'type',
    'filename',
    'content_type',
] as const

/**
 * Create one promo
 */
function createPromo(promo: PromoCreation) {
    const body = ObjectUtils.copy(promo, CreateDeviceFields, {
        date_start: (v: Date) => moment(v).format('YYYY-MM-DD'),
        date_end: (v: Date) => moment(v).format('YYYY-MM-DD'),
        filename: () => promo.promo_img.name,
        content_type: () => promo.promo_img.type,
        group_skus: ArrayUtils.cleanStringArray,
        exception_countries: ArrayUtils.cleanStringArray,
        exception_dates: (v: Date[]) => v.map((d) => moment(d).format('YYYY-MM-DD')).join(','),
        exception_devices: ArrayUtils.cleanStringArray,
        exception_stores: ArrayUtils.cleanStringArray,
        exception_skus: ArrayUtils.cleanStringArray,
    })

    return createAction<RootState, Promo, never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos`,
        method: 'POST',
        body: JSON.stringify(body),
        types: [
            ActionTypes.PROMO_CREATE_REQUEST,
            ActionTypes.PROMO_CREATE_SUCCESS,
            ActionTypes.PROMO_CREATE_FAILURE,
        ],
    })
}

export type PromoCreateAction = PromoCreateRequest
    | PromoCreateFailure
    | PromoCreateSuccess

export default createPromo
